module.exports = __webpack_public_path__ + "static/media/hackerrank_logo.e64d2a29.png";